import { render } from "./trend-chart.vue?vue&type=template&id=10187350&scoped=true&ts=true"
import script from "./trend-chart.vue?vue&type=script&lang=ts"
export * from "./trend-chart.vue?vue&type=script&lang=ts"

import "./trend-chart.vue?vue&type=style&index=0&id=10187350&lang=stylus&scoped=true"

import exportComponent from "D:\\Repository\\Zidan\\pc-customer-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10187350"]])

export default __exports__